import { config, oidcConfig } from "./config";

// Where to come back to after signing in again. The sign-in return page's state and code work
// once, so from there the user goes home; window.location is always this site's own address
// bar, never an attacker-supplied value, so there is nothing here to validate as same-origin.
export const signInReturnPath = ({ pathname, search, hash = "" } = window.location) => {
    if (!oidcConfig.redirect_uri) {
        console.error("[signInReturnPath] REACT_APP_REDIRECT_URI is not configured; cannot detect the sign-in return page.");
        return pathname.replace(/^\/+/, "/") + search + hash;
    }
    const returnPagePath = new URL(oidcConfig.redirect_uri, window.location.origin).pathname;
    return pathname === returnPagePath ? "/" : pathname.replace(/^\/+/, "/") + search + hash;
}

export const clearOidcSession = () => {
    // @axa-fr/oidc-client (v7) stores this app's one OIDC configuration under a single
    // "oidc.default" key (initSession.ts's `oidc.${configurationName}`) in whichever Storage
    // oidcConfig.storage names - localStorage since the token-renewal fix, not v3 oidc-client's
    // "oidc.user:<authority>:<client_id>" scheme this used to scan for. Clearing both storages
    // (matching CenterPoint/React/src/utils/oidcUtilities.js) keeps this correct regardless of
    // which one the configured client is actually using.
    sessionStorage.removeItem("oidc.default");
    localStorage.removeItem("oidc.default");
}

export const changeCompany = () => {
    // Keycloak has no hosted /customerresolve page (that was IdentityServer's); the in-app
    // picker at /select-company stays signed in and refreshes the token in place instead.
    if (config.useKeycloak) {
        window.location.href = `${window.location.origin}/select-company`;
        return;
    }
    clearOidcSession();
    let url = config.identityBaseUrl;
    var lastChar = url.substr(-1);
    if (lastChar === "/") {
        url = url.substring(0, url.length - 1);
    }
    window.location.href = url + "/customerresolve";
}
